<template>
    <div>
        <div style="font-weight: bold;color: #000;">小型坝数量统计</div>
        <div class="selectTool">
          <el-select size="mini" v-model="shengValue" clearable :disabled="disabled1==true" placeholder="请选择省" @change="shengChange">
            <el-option v-for="item in sheng" :key="item.regionCode" :label="item.regionName" :value="item.regionCode">
            </el-option>
          </el-select>
          <el-select size="mini" v-model="shiValue" clearable :disabled="disabled2==true" placeholder="请选择市" @change="shiChange">
            <el-option v-for="item in shi" :key="item.regionCode" :label="item.regionName" :value="item.regionCode">
            </el-option>
          </el-select>
          <el-select size="mini" v-model="xianValue" clearable :disabled="disabled3==true" placeholder="请选择县" @change="xianChange">
            <el-option v-for="item in xian" :key="item.regionCode" :label="item.regionName" :value="item.regionCode">
            </el-option>
          </el-select>
      </div>
        <div style="flex:1;">
          <span
            v-if="countXxb != 0"
            style="float: left;margin-top: 5px;margin-left: 10px;color: #000;font-size: 14px;"
            >总和：{{ countXxb }}</span
          >
          <div v-show="showChart == true" style="width: 100%;height: 400px;" id="xxbPie"></div>
          <div v-show="showChart == false" style="width: 100%;line-height: 400px;text-align: center;" >暂无数据</div>
        </div>  
    <dataListDialog v-if="dataListDialogVisible == true" @getDatalistcancel="getDatalistCancel" :regionType="regionType"  :regionCode="regionCode" :type="'xxb'"></dataListDialog>
</div>
</template>

<script>
import { initRegion, getRegion,yjzxStatistic } from "@/api/api.js";
import dataListDialog from './dataListDialog.vue'
export default {
  components:{
    dataListDialog
  },
  data() {
    return {
      disabled1: false,
      disabled2: false,
      disabled3: false,
      sheng: [],
      shi: [],
      xian: [],
      shengValue: '',
      shiValue: '',
      xianValue: '',
      shengCode: '',
      shiCode: '',
      xianCode: '',
      statisticDialogVisible: true,
      //省市县参数
      shengData: null,
      shiData: null,
      xianData: null,
      xxbPie: null,
      regionCode:'',
      dataListDialogVisible: false,
      regionType: '0' ,//区域类型是0表示省
      countXxb: 0,
      xxbDataList: [],
      showChart : true   
    };
  },
  created() {  
    this.initRegionFun();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.resize());
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    if (this.xxbPie) {
      this.xxbPie.dispose(); // 清理图表实例
    }
  },
  methods: {
    initRegionFun() {
      initRegion().then((res) => {
        // console.log('gis--->', res)
        this.sheng = res.sheng;
        this.shi = res.shi;
        this.xian = res.xian;
        if (this.sheng.length == 1) {
          this.shengValue = this.sheng[0].regionName;
          this.disabled1 = true;
        } else {
          this.shengValue = '';
          this.disabled1 = false;
        }
        if (this.shi.length == 1) {
          this.shiValue = this.shi[0].regionName;
          this.disabled2 = true;
        } else {
          this.shiValue = '';
          this.disabled2 = false;
        }
        if (this.xian.length == 1) {
          this.xianValue = this.xian[0].regionName;
          this.disabled3 = true;
        } else {
          this.xianValue = '';
          this.disabled3 = false;
        }
        this.getData();  
      })
    },
    getData(data){
      this.countXxb = 0;
      let params = {
            regionCode: data ? data : this.$store.state.regionCode
        };     
      yjzxStatistic(params).then((res=>{
        if(res.data && res.data.xxbStatistic && res.data.xxbStatistic.statisticResult.length > 0){
          this.yjzxData = res.data.xxbStatistic.statisticResult;
          let dataList = res.data.xxbStatistic.statisticResult;
          dataList.forEach(ele => {
            if(this.xianValue){
              this.regionType = '3'//区域类型是3表示县级别
            }else if(this.shiValue){
              this.regionType = '2';//区域类型是3表示县级别
            }else if(this.shengValue){
              this.regionType = '1' //区域类型是1表示市级别
            }          
            this.countXxb += ele.count; 
          });
          this.showChart = true;
          this.initPie(res.data.xxbStatistic.statisticResult);          
        }else {
          this.showChart = false;
        }

      }))

    },
    resize() {
      if(this.xxbPie){
        this.xxbPie.resize();
      }
     
    },
    initPie(dataList) {
      let _this = this;
      this.xxbPie = this.$echarts.init(document.getElementById("xxbPie"));
      let option = {
        legend: {
          orient:'vertical',
          left:'right',
          top: 10,
          data: dataList.map(item => {
              return {
                name: item.regionName,
              };
            }),
          textStyle: {
            color: "#000"
          }
        },
        tooltip: {
          trigger: "item"
          // formatter: xzqhCityName+' <br/>{b}: {c} '
        },
        series: [
          {
            type: "pie",
            radius: [0, "70%"],
            label: {
              position: "inner",
              fontSize: 14,
              formatter: "{c}"
            },
            startAngle: 270,
            labelLine: {
              show: false
            },
            data: dataList.map(item => {
                return {
                  name: item.regionName,
                  value: item.count,
                  code: item.regionCode
                };
              })
            
          }
        ]
      };
      this.xxbPie.clear();
      this.xxbPie.setOption(option);
      this.xxbPie.on('click', function(value) {
          _this.dataListDialogVisible = true;
          _this.regionCode = value.data.code;
         
        });
    },
    shengChange(value) {
      let params = {
        regionCode: value
      };
      getRegion(params).then((res) => {
        // console.log(res)
        this.shi = res.data;
        this.getData(value)
      });
      this.shiValue = '';
      this.xianValue = '';
    },
    shiChange(value) {
      value = value?value:this.shengValue;
      let params = {
        regionCode: value
      };
      getRegion(params).then((res) => {
        // console.log(res)
        this.xian = res.data;
        this.getData(value);
      });
      this.xianValue = '';
    },
    xianChange(value) {
      value = value?value:this.shiValue;
      this.getData(value);
    },
    getDatalistCancel(){
      this.dataListDialogVisible = false;
    }
  }
};
</script>

<style scoped="scoped">
.totalPie,
.zrrlist {
  width: 100%;
  height: 270px;
  background: url(../../../common/images/contentborder.png) no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;
  font-size: 16px;
}
>>> .el-dialog {
  width: 50%;
}
.el-dialog__body {
  max-height: 200px;
  overflow: auto;
}
.el-form-item__error {
  padding-top: 0;
}
.el-input__inner {
  padding-right: 0;
}
.selectTool {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  max-height: 500px;
  /* z-index: 100; */
}
</style>
